(function(){
	'use strict';

	angular
		.module('app.products')
		.controller('ProductDetailsController', ProductDetailsController);

	function ProductDetailsController(API, apiConfig, $state, $filter) {
		let vm = this;

		vm.APIConfig = apiConfig;

		vm.product = [];
		vm.loadProduct = false;

		vm.$onInit = () => {
			_loadFromApi();
		}

		function _loadFromApi() {
		  _loadProduct();
			_loadIsolamentoImages();
			_loadFixacao();
		}

		function _loadProduct() {
			const slug = $state.params.slug;
			API.get(`produto_brastelha/${slug}`)
				.then(result => result.data)
				.then(product => {
					product = product[0];

					if(product.slug_categoria.toUpperCase() == 'BRAS-X')
						$state.go('home');

					product.imagens_aplicacao = $filter('filter')(product.imagens, {posicao_imagem : 1});
					product.imagens_miniatura = $filter('filter')(product.imagens, {posicao_imagem : 2});
					product.imagens_isolamento = $filter('filter')(product.imagens, {posicao_imagem : 3});
					product.imagens_acabamento = $filter('filter')(product.imagens, {posicao_imagem : 4});
					
					if(product.imagens_miniatura != undefined){
					  var imagem_principal = {
					    'nome_imagem' : product.imagem_produto
					  }
					  product.imagens_miniatura.unshift(imagem_principal);
					}else{
					  product.imagens_miniatura = 0;
					}

					if(product.medidas_produto){
						product.medidas_produto = product.medidas_produto.split(';');
						product.medidas_produto = product.medidas_produto.map(function(item, index){
						  return index % 4 === 0 ? product.medidas_produto.slice(index, index + 4) : null;
						  })
						  .filter(function(item){ return item;
						});
					}

					if(typeof product.imagens_acabamento == 'undefined'){
						API.get('paginas/21').then(result => vm.acabamentos = result.data[0].imagens);
					}else if(product.imagens_acabamento.length == 0){
						API.get('paginas/21').then(result => vm.acabamentos = result.data[0].imagens);
					}else{
						vm.acabamentos = product.imagens_acabamento;
					}	

					return product;
				})
				.then(product => vm.product = product)
				.then(() => vm.loadProduct = true)
				.catch(error => {
					console.log(error, 'error');
				});
			}

		function _loadFixacao(){
			API.get('projeto').then(result => vm.fixacao = result.data);
		}

		function _loadIsolamentoImages() {
			API.get('paginas/10')
				.then(result => result.data)
				.then(imagens => vm.isolamentoImagens = imagens[0])
				.then(() => console.log(vm.isolamentoImagens))
		}

	}

})();
